import { Controller } from "@hotwired/stimulus";
import ace from "ace-builds/src-noconflict/ace";
import "ace-builds/src-noconflict/mode-html";
import "ace-builds/src-noconflict/mode-css";
import "ace-builds/src-noconflict/mode-javascript";

// Connects to data-controller="ace-editor"
export default class extends Controller {
  static values = {
    mode: { type: String, default: "html" },
  };

  connect() {
    if (this.element.dataset.aceified) return;
    this.element.dataset.aceified = true;

    const div = document.createElement("div");
    this.element.after(div);
    this.element.style.display = "none";

    const editor = ace.edit(div);
    editor.session.setValue(this.element.value);
    editor.session.setMode(`ace/mode/${this.modeValue}`);
    editor.session.setUseWorker(false);
    editor.setOptions({
      autoScrollEditorIntoView: true,
      copyWithEmptySelection: true,
      highlightActiveLine: true,
      showPrintMargin: false,
      tabSize: 2,
      useSoftTabs: true,
      wrap: true,
      wrapBehavioursEnabled: true,
    });

    editor.commands.addCommand({
      name: "submitForm",
      bindKey: { win: "Ctrl-Enter", mac: "Command-Enter" },
      exec: () => {
        this.element.form.requestSubmit();
      },
    });

    this.editor = editor;
    this.editorDiv = div;
    this.boundSubmit = () => {
      this.element.value = this.editor.getSession().getValue();
    };
    this.element.form.addEventListener("submit", this.boundSubmit);
  }

  modeValueChanged() {
    if (this.editor) {
      this.editor.session.setMode(`ace/mode/${this.modeValue}`);
    }
  }

  disconnect() {
    if (this.boundSubmit && this.element.form) {
      this.element.form.removeEventListener("submit", this.boundSubmit);
    }
    if (this.editor) {
      this.editor.destroy();
      this.editor = null;
    }
    if (this.editorDiv) {
      this.editorDiv.remove();
      this.editorDiv = null;
    }
  }
}
